import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Download, RefreshCw } from 'lucide-react';

const AppUpdateRequiredModal = ({
  isOpen,
  mandatory,
  currentVersion,
  latestVersion,
  minVersion,
  downloadUrl,
  onUpdate,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            className="w-full max-w-md card-glass p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-accent/20 flex items-center justify-center">
                <RefreshCw size={20} className="text-accent" />
              </div>
              <div className="flex-1">
                <h2 className="text-xl font-bold">
                  {mandatory ? 'Actualización obligatoria' : 'Actualización disponible'}
                </h2>
                <p className="text-xs text-text/60">
                  {mandatory
                    ? 'Debes actualizar para continuar usando la app.'
                    : 'Recomendamos actualizar para obtener mejoras y correcciones.'}
                </p>
              </div>
            </div>

            <div className="space-y-2 mb-6 text-sm">
              <div className="flex items-center justify-between bg-glass/40 rounded-lg px-3 py-2">
                <span className="text-text/60">Tu versión</span>
                <span className="font-semibold">{currentVersion || '—'}</span>
              </div>
              <div className="flex items-center justify-between bg-glass/40 rounded-lg px-3 py-2">
                <span className="text-text/60">Última versión</span>
                <span className="font-semibold">{latestVersion || '—'}</span>
              </div>
              {minVersion ? (
                <div className="flex items-center justify-between bg-glass/40 rounded-lg px-3 py-2">
                  <span className="text-text/60">Mínima requerida</span>
                  <span className="font-semibold">{minVersion}</span>
                </div>
              ) : null}
            </div>

            <button
              type="button"
              className="w-full px-4 py-3 rounded-lg bg-accent text-dark font-semibold hover:opacity-95 flex items-center justify-center gap-2"
              onClick={onUpdate}
            >
              <Download size={18} />
              Actualizar ahora
            </button>

            {downloadUrl ? (
              <p className="text-[11px] text-text/40 mt-3 break-all">
                {downloadUrl}
              </p>
            ) : null}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AppUpdateRequiredModal;
